import { APP_BASE_PATH } from './appBasePath';

export const HUB_MFE = 'stc-hub-ui';
export const APPRAISAL_MFE = 'stc-appraisal-ui';

export type MfeName = typeof HUB_MFE | typeof APPRAISAL_MFE;

// Mirrors the Shell route table in src/Routes.tsx — keep in sync.
const HUB_PATH_PREFIXES: readonly string[] = ['hub', 'confirmation', 'plaid-redirect'];
const APPRAISAL_PATH_PREFIXES: readonly string[] = ['getoffer', 'offer', 'refresh'];

const getPathUnderBase = (pathname: string | undefined | null): string | undefined => {
  if (!pathname) return undefined;
  const base = APP_BASE_PATH.endsWith('/') ? APP_BASE_PATH.slice(0, -1) : APP_BASE_PATH;
  if (!pathname.startsWith(base)) return undefined;
  return pathname.slice(base.length).replace(/^\/+/, '') || undefined;
};

const matchesPrefix = (rest: string, prefixes: readonly string[]): boolean =>
  prefixes.some(prefix => rest === prefix || rest.startsWith(`${prefix}/`));

export const getAppForPath = (pathname: string | undefined | null): MfeName | undefined => {
  const rest = getPathUnderBase(pathname);
  if (!rest) return undefined;
  if (matchesPrefix(rest, HUB_PATH_PREFIXES)) return HUB_MFE;
  if (matchesPrefix(rest, APPRAISAL_PATH_PREFIXES)) return APPRAISAL_MFE;
  return undefined;
};

export const getAppForUrl = (url: string | undefined | null): MfeName | undefined => {
  if (!url) return undefined;
  try {
    return getAppForPath(new URL(url, window.location.origin).pathname);
  } catch {
    return undefined;
  }
};
